module.exports = __webpack_public_path__ + "static/media/CSP2.63d7a1d4.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/CSP2.png
// module id = 903
// module chunks = 0